module.exports = __webpack_public_path__ + "images/edges@1x.png?67430fca";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/edges@1x.png
// module id = 615
// module chunks = 7